import { render } from "./ClinicStep.vue?vue&type=template&id=7b1387f0&ts=true"
import script from "./ClinicStep.vue?vue&type=script&lang=ts"
export * from "./ClinicStep.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__